export const FETCH_DEVICES_SETTINGS = "FETCH_DEVICES_SETTINGS";
export const fetchDevicesSettingsAction = (devices) => {
  return {
    type: "FETCH_DEVICES_SETTINGS",
    payload: devices,
  };
};
